import { render, staticRenderFns } from "./AmountInputs.vue?vue&type=template&id=5eb100b3&"
import script from "./AmountInputs.vue?vue&type=script&lang=js&"
export * from "./AmountInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports